module.exports = __webpack_public_path__ + "static/media/person7.ff8a65f4.jpg";